import { Button, ButtonGroup, Drawer, NonIdealState, Tooltip } from '@blueprintjs/core';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import proyectosService from '../../services/proyectos.service';
import { AppContext } from '../../utils/context/app.context';
import { toast, ToastContainer } from 'react-toastify';
import { AuthContext } from '../../utils/context/auth.context.ts';
import { useLocation } from 'react-router';
import TableApp from '../../utils/components/table.component.js';
import ProyectoEntregablesCli from './entregables.cli.component.js';

export default function ProyectosCli(props) {
    const { id } = props;
    const [data, setData] = useState([])
    const [isOpen, setOpen] = useState(false)
    const [item, setItem] = useState(null)
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(20)
    const [isLoading, setLoading] = useState(false)
    const { t } = useTranslation();
    const appContext = useContext(AppContext)
    const authContext = useContext(AuthContext)
    const location = useLocation()

    function list(_page = null, _pageSize = null, field, value) {
        if (authContext.verify(location, "GET")) {
            setLoading(true);
            if (field && value) proyectosService.search_cli(_page || page, _pageSize || pageSize, field, value)
                .then(res => {
                    setData(res.data);
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => {
                    setLoading(false);
                })
            else proyectosService.list_cli(_page || page, _pageSize || pageSize)
                .then(res => {
                    setData(res.data);
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => {
                    setLoading(false);
                })
        } else {
            toast.warning(t('auth.nopermit'))
        }

    }

    const columns = [
        {
            name: t("pro.table.action"),
            width: '160px',
            omitCsv: true,
            component: row => <>
                <ButtonGroup>
                    {authContext.verify({ pathname: "/documentos" }, "GET") ? <ProyectoEntregablesCli proyecto={row} /> : null}
                </ButtonGroup>
            </>,
        },
        {
            name: t("pro.table.codigo"),
            value: "codigo",
            text: row => row.codigo,
            component: row => <>
                {` ${row.codigo}`}
            </>
        },
        {
            name: t("pro.table.estado"),
            text: row => t(`general.pro_states.${row.estado}`),
        },
    ];

    useEffect(() => {
        list()
    }, []);

    return (<>

        <ToastContainer theme="colored" />

        <TableApp
            data={data}
            columns={columns}
            loading={isLoading}
            title={t("pro.table.title")}
            
            reload={list}
            reloadPag
            onChangePage={setPage}
            onChangeRowsPerPage={setPageSize}
        />


    </>
    );
}
